import { createSelector } from 'reselect'

import { RootState } from 'core/reducers'

const getPeriodTimesState = (state: RootState) => state?.periodTimes

export const getPeriodTimes = createSelector([getPeriodTimesState], (state) => state?.single?.data)
